import React from 'react';
import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';

import { FilterBarSettings } from '../filterBarSettings';

import ReportQuickFiltersSettings from './ReportQuickFiltersSettings';

const ReportQuickFiltersModal = ({
  settings,
  isOpen,
  close,
}: {
  settings: FilterBarSettings;
  isOpen: boolean;
  close: () => void;
}) => (
  <ModalTransition>
    {isOpen && (
      <ModalDialog
        onClose={close}
        shouldScrollInViewport={false}
        autoFocus={false}
      >
        <ReportQuickFiltersSettings settings={settings} close={close} />
      </ModalDialog>
    )}
  </ModalTransition>
);

export default ReportQuickFiltersModal;
